export default __webpack_public_path__ + "static/media/Sliderimg04.ea9d2109.jpg";